import { IDirectDealFilter } from '../../constants/filter/directDealFilter.constant';
import { IMarketPriceFilter } from '../../constants/filter/marketPriceFilter.constant';
import { IProductFilter } from '../../constants/filter/productFilter.constant';
import { IUserOwnTractorFilter } from '../../constants/filter/userOwnTractorFilter.constant';
import { FilterType } from '../../interfaces/Filter.interfaces';
import { createDirectDealFilterSearchParams } from './createDirectDealFilterSearchParams.util';
import { createMarketPriceFilterSearchParams } from './createMarketPriceFilterSearchParams.util';
import { createProductFilterSearchParams } from './createProductFilterSearchParams.util';
import { createUserOwnTractorFilterSearchParams } from './createUserOwnTractorFilterSearchParams.util';

interface ICreateSearchParamBySelectedFilterOptionParam {
  filterType: FilterType;
  filters: IProductFilter[] | IUserOwnTractorFilter[] | IMarketPriceFilter[] | IDirectDealFilter[];
}

export const createSearchParamBySelectedFilterOption = ({
  filterType,
  filters,
}: ICreateSearchParamBySelectedFilterOptionParam): object => {
  if (filterType === 'productFilter') {
    const searchParam = createProductFilterSearchParams({ filters: filters as IProductFilter[] });
    return searchParam;
  }

  if (filterType === 'userOwnTractorFilter') {
    const searchParam = createUserOwnTractorFilterSearchParams({ filters: filters as IUserOwnTractorFilter[] });
    return searchParam;
  }

  if (filterType === 'marketPriceFilter') {
    const searchParam = createMarketPriceFilterSearchParams({ filters: filters as IMarketPriceFilter[] });
    return searchParam;
  }

  if (filterType === 'directDealFilter') {
    const searchParam = createDirectDealFilterSearchParams({ filters: filters as IDirectDealFilter[] });
    return searchParam;
  }

  return {};
};
